import React from 'react'
import { cacheExchange, Client, fetchExchange, Provider } from 'urql'
import { Bootstrap } from './Bootstrap'
import { getAuthorizationToken } from '../modules/authentication/storage'
import { BusinessLocationProvider } from '../context/BusinessLocationContext'
import { GoogleOAuthProvider } from '@react-oauth/google'
import {API_URL} from "../utils/env";

const client = new Client({
  url: `${API_URL}/graphql`,
  exchanges: [cacheExchange, fetchExchange],
  fetchOptions() {
    return {
      headers: {
        authorization: `Bearer ${getAuthorizationToken()}` ?? '',
      },
    }
  },
})

export const Root: React.FC = () => {
  return (
    <Provider value={client}>
      <BusinessLocationProvider>
        <GoogleOAuthProvider clientId="1036662147084-31mcdgid59rt5dma42je2ntua0drtuu4.apps.googleusercontent.com">
          <Bootstrap />
        </GoogleOAuthProvider>
      </BusinessLocationProvider>
    </Provider>
  )
}
